export default "__VITE_PUBLIC_ASSET__ceebe679__"